module.exports = __webpack_public_path__ + "static/media/Institutional lender Infographic Mobile - CBON Network - 25-07-2024 N.cb42a09e.gif";